/**
 * src/app/venue/VenueApp.tsx — 2004va
 *
 * Routing tree for venue-mode. Mounted from the root App.tsx at /venue/*.
 *
 * Routes:
 *   /venue                     → redirect to /venue/enter
 *   /venue/enter               → code-entry page (no venue yet)
 *   /venue/:slug/enter         → code-entry page for a specific venue slug
 *                                (future: deep-link from invitation emails)
 *   /venue/:slug/*             → protected layout (digest, approvals, queue, search)
 *
 * The picker session is scoped by venue slug in localStorage. Entering
 * a code creates the row in venue_pickers and stores { picker_id, venue_id,
 * venue_slug, display_name, session_type } in localStorage so the session
 * survives tab close, mobile back-button, and PWA relaunch. Explicit
 * sign-out clears it.
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import { VenueEnterPage }        from '@/pages/venue/VenueEnterPage'
import { VenueProtectedLayout }  from './VenueProtectedLayout'

export function VenueApp() {
  return (
    <Routes>
      <Route index            element={<Navigate to="enter" replace />} />
      <Route path="enter"     element={<VenueEnterPage />} />
      <Route path=":slug/enter" element={<VenueEnterPage />} />
      <Route path=":slug/*"   element={<VenueProtectedLayout />} />
    </Routes>
  )
}
